import React from 'react';

import { Layout } from 'antd';
import { MenuItemType } from 'antd/es/menu/interface';
import { COMPANY_NAME } from 'app-config';

// import DashboardHeader from '../DashboardHeader/DashboardHeader';
import DashboardSidebar from '../DashboardSidebar/DashboardSidebar';

import './DashboardLayout.scss';

type Props = {
  children?: React.ReactNode;
  sideMenu: MenuItemType[];
};

const DashboardLayout = ({ children, sideMenu }: Props) => (
  <Layout className="dashboard-layout">
    <DashboardSidebar items={sideMenu} />
    <Layout>
      {/* <DashboardHeader /> */}
      <Layout.Content className="dashboard-layout__content">
        <div className="dashboard-layout__container">
          {children}
        </div>
      </Layout.Content>
      <Layout.Footer className="dashboard-layout__footer">
        {COMPANY_NAME}
        {' '}
        © 2024
      </Layout.Footer>
    </Layout>
  </Layout>
);

export default DashboardLayout;
